import React from 'react'
import PropTypes from 'prop-types';

import Label from '../label';
import Icon from '../icon/icons/icon';
import * as models from '../icon/icons';

import './button.styl'
class ButtonPush extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        value: PropTypes.bool.isRequired,
        className: PropTypes.string,
        iconOn: PropTypes.string.isRequired,
        iconOff: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        onClick: PropTypes.func.isRequired
    }

    static defaultProps = {
        className: false,
        label: false,
        disabled: false
    }

    state = {
        value: this.props.value
    }

    handleChange(){
        if(this.props.disabled) return

        this.props.onClick(!this.props.value)
        this.setState({value: !this.state.value})
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.value !== this.state.value) {
            this.setState({value: nextProps.value})
        }
    }

    render() {
        const {value} = this.state
        const {label, iconDisabled, disabled} = this.props
        let {iconOn, iconOff, className} = this.props

        iconOn = models[iconOn] && models[iconOn].length ? models[iconOn] : false;
        iconOff = models[iconOff] && models[iconOff].length ? models[iconOff] : false;

        className = className ? ' ' + className : ''
        disabled && (className = className + (disabled ? ' disabled' : ''))

        return <div className={"button button-push" + className} onClick={this.handleChange.bind(this) } >
            <div className="button-push-icon">
                {iconOn && value && <Icon svg={iconOn} />}
                {iconOff && !value && <Icon svg={iconOff} />}
            </div>
            {label && <Label>{label}</Label>}
        </div>
    }
}

export default ButtonPush
